import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';

export default class ContractPreview extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            controllerName: 'contract'
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/" + this.state.controllerName + "/print", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 0) {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
            else {
                this.setState({
                    data: data,
                    loading: false
                })
            }
        });
    }
    approve(e) {
        e.preventDefault();

        this.httpPost("api/v1/contract/approve", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("تایید قرارداد با موفقیت ثبت شد.");
                this.setState({
                    redirect: '/contracts/my/'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    reject(e) {
        e.preventDefault();

        this.httpPost("api/v1/contract/reject", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("عدم پذیرش قرارداد با موفقیت ثبت شد.");
                this.setState({
                    redirect: '/contracts/my/'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return<div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">

                            <div className="nk-block-head">
                                <div className="nk-block-between g-3">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title page-title">پیش نمایش قرارداد</h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                        {this.state.data.record.status == 2 && <a onClick={e => this.reject(e)} className="btn btn-danger me-3"><span>عدم پذیرش</span></a>}
                                        {this.state.data.record.status == 2 && <a onClick={e => this.approve(e)} className="btn btn-success me-3"><span>تایید قرارداد</span></a>}
                                        <NavLink to="/payslips/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>
                                        <NavLink to="/payslips" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>
                                    </div>
                                </div>
                            </div>
                            <div className="nk-block nk-block-lg">
                                <embed src={"data:application/pdf;base64,"+this.state.data.bs64} type="application/pdf" width="100%" height="600px" />
                            </div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>,
                        <Footer />
                    ];

        return contents;
    }
}